import { render } from "./ImportServicos.vue?vue&type=template&id=6f44c6e0&ts=true"
import script from "./ImportServicos.vue?vue&type=script&lang=ts"
export * from "./ImportServicos.vue?vue&type=script&lang=ts"

import "./ImportServicos.vue?vue&type=style&index=0&id=6f44c6e0&lang=css"

import exportComponent from "/Users/camp/Desktop/code-time/acampa-gestao-pra/vuecode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__